import React from "react";
import { useResponse } from "screens/question/hooks";
import { ReactTable, CheckBox } from "components";

export const MultipleQuestion = ({ question, childQuestions }) => {
  const { options, representation_type } = question;

  const columns = React.useMemo(() => {
    let cols = options.map(option => {
      return { Header: option.text, accessor: option.text };
    });
    cols.splice(0, 0, { Header: " ", accessor: " " });
    return cols;
  }, [options]);

  const { selectedOptions, selectOption } = useResponse(question);

  const data = React.useMemo(() => {
    return childQuestions.map(subQuestion => {
      const row = {};
      row[" "] = subQuestion.text;
      const selectedQuestion = selectedOptions[subQuestion.virtual_id];
      const selectedOption =
        selectedQuestion && Object.keys(selectedQuestion.options);
      subQuestion.options.forEach((option, i) => {
        const checkedOption = selectedOption
          ? selectedOption.includes(String(option.virtual_id))
          : false;
        const checkboxProps = {
          icon: "radioCircle",
          score: option.score,
          representation_type,
          checked: !!checkedOption,
          onPress: () => {
            selectOption(subQuestion, option);
          },
        };
        row[option.text] = <CheckBox {...checkboxProps} />;
      });
      return row;
    });
  }, [childQuestions, representation_type, selectOption, selectedOptions]);

  return <ReactTable columns={columns} data={data} />;
};
